import { cn } from "@/lib/utils";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";

interface UploadProgressProps {
  progress: number;
  isUploading: boolean;
  fileName?: string;
  onCancel?: () => void;
  className?: string;
}

export function UploadProgress({
  progress,
  isUploading,
  fileName,
  onCancel,
  className,
}: UploadProgressProps) {
  if (!isUploading && progress === 0) return null;

  return (
    <div className={cn("space-y-2 p-4 bg-muted/50 rounded-md border", className)}>
      <div className="flex justify-between items-center text-sm">
        <div className="flex items-center gap-2 min-w-0 flex-1">
          {isUploading && (
            <div className="h-4 w-4 border-2 border-primary border-t-transparent rounded-full animate-spin shrink-0" />
          )}
          <span className="text-muted-foreground truncate">
            {fileName || "Uploading video..."}
          </span>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <span className="text-muted-foreground font-medium">{progress}%</span>
          {onCancel && isUploading && (
            <Button
              type="button"
              size="icon"
              variant="ghost"
              className="h-6 w-6"
              onClick={onCancel}
            >
              <X className="h-3 w-3" />
            </Button>
          )}
        </div>
      </div>
      <div className="h-2 bg-muted rounded-full overflow-hidden">
        <div
          className="h-full bg-primary transition-all duration-300 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}
